import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const EASE = [0.16, 1, 0.3, 1];

const INCLUDED = [
  "Personalised workouts",
  "Nutrition, sleep, hydration & recovery",
  "Mindfulness & meditation",
  "Self-reflection & self-awareness tools",
];

export const Pricing = () => (
  <section
    id="pricing"
    data-testid="pricing-section"
    className="relative scroll-mt-24 overflow-hidden py-24 sm:py-32"
  >
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "radial-gradient(circle at 50% 100%, rgba(245, 230, 227, 0.8) 0%, rgba(250, 246, 240, 0) 60%)",
      }}
    />
    <div className="relative mx-auto max-w-xl px-4 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: EASE }}
        className="rounded-[2.5rem] border border-white/70 bg-white/85 p-10 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] backdrop-blur-xl sm:p-14"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-dark">Pricing</p>
        <h2 className="mt-4 font-serif text-2xl tracking-tight text-ink sm:text-3xl">
          841 membership
        </h2>

        <div className="mt-8 flex items-baseline justify-center gap-2" data-testid="pricing-amount">
          <span className="font-serif text-6xl tracking-tight text-ink sm:text-7xl">₹499</span>
          <span className="text-sm text-[#8A8079]">/month</span>
        </div>

        <span
          data-testid="pricing-trial-badge"
          className="mt-6 inline-block rounded-full border border-[rgba(195,153,83,0.35)] bg-blush-light px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-gold-dark"
        >
          1 week free trial
        </span>

        <div className="mx-auto mt-9 h-px w-24 bg-gradient-to-r from-transparent via-[rgba(195,153,83,0.5)] to-transparent" />

        <ul className="mx-auto mt-8 max-w-xs space-y-3.5 text-left">
          {INCLUDED.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm text-[#4A433F]">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/12 text-gold-dark">
                <Check size={12} />
              </span>
              {item}
            </li>
          ))}
        </ul>

        <button
          data-testid="pricing-join-button"
          onClick={() => scrollToId("home")}
          className="mt-10 w-full rounded-full bg-ink px-8 py-4 text-sm tracking-wide text-sand transition-colors duration-300 hover:bg-gold-dark"
        >
          Join the waitlist
        </button>
        <p className="mt-4 text-xs text-[#8A8079]">
          Be first in line — your free week begins when 841 launches.
        </p>
      </motion.div>
    </div>
  </section>
);
